import React from 'react';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, {
            extra: { componentStack: errorInfo.componentStack }
        });
        console.error('React Error Boundary caught:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '40px', textAlign: 'center' }}>
                    <h2>Что-то пошло не так</h2>
                    <p>An unexpected error occurred. Please reload the page.</p>
                    <button
                        onClick={function() { window.location.reload(); }}
                        style={{ padding: '10px 20px', cursor: 'pointer' }}
                    >
                        Reload
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/Components/ErrorBoundary/index.js